import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslations } from "../data/translations/index";
import { useReveal } from "../hooks/useReveal";
import { CountUp } from "./CountUp";
import "../styles/HomeItem.css";

export const HomeItem = () => {
  const { language } = useLanguage();
  const { Home } = getTranslations(language);
  const rootRef = useRef(null);
  useReveal(rootRef, language);

  return (
    <div className="home" ref={rootRef}>
      <section className="home-hero container">
        <div className="home-hero__text">
          <p className="eyebrow" data-reveal>
            {Home.eyebrow}
          </p>

          <h1 className="home-hero__headline" data-reveal>
            {Home.headline.lead}
            <em className="home-hero__accent">{Home.headline.accent}</em>
            {Home.headline.tail}
          </h1>

          <p className="home-hero__intro" data-reveal style={{ "--reveal-delay": "0.08s" }}>
            {Home.intro}
          </p>

          <div className="home-hero__actions" data-reveal style={{ "--reveal-delay": "0.16s" }}>
            <a
              href={Home.cv.href}
              className="btn btn--primary"
              download={Home.cv.download}
            >
              <i className={Home.cv.icon} aria-hidden="true" />
              {Home.cv.text}
            </a>
            <Link to={Home.secondaryCta.href} className="btn btn--ghost">
              {Home.secondaryCta.text}
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>

        <figure className="home-hero__portrait" data-reveal>
          <img src={Home.image} alt={Home.name} />
          <figcaption className="home-hero__signature">{Home.name}</figcaption>
        </figure>
      </section>

      <section className="home-facts container" aria-label={Home.name}>
        <dl className="home-facts__grid">
          {Home.facts.map((fact, index) => (
            <div
              className="home-facts__item"
              key={fact.label}
              data-reveal
              style={{ "--reveal-delay": `${index * 0.07}s` }}
            >
              <dt className="home-facts__value">
                <CountUp value={fact.value} />
              </dt>
              <dd className="home-facts__label">{fact.label}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="home-panel container">
        <div className="home-panel__inner glass glass--strong" data-reveal>
          <div className="home-panel__block">
            <p className="eyebrow">{Home.toolsLabel}</p>
            <ul className="home-tools">
              {Home.tools.map((tool) => (
                <li className="home-tools__chip" key={tool}>
                  {tool}
                </li>
              ))}
            </ul>
          </div>

          <div className="home-panel__block">
            <p className="eyebrow">{Home.contactLabel}</p>
            <ul className="home-contact">
              {Home.contactInfo.map((item) => (
                <li className="home-contact__row" key={item.text}>
                  <i className={item.icon} aria-hidden="true" />
                  {item.href ? (
                    <a
                      href={item.href}
                      target={item.href.startsWith("http") ? "_blank" : undefined}
                      rel="noopener noreferrer"
                    >
                      {item.text}
                    </a>
                  ) : (
                    <span>{item.text}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};
